import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-meeting-data-for-appointment',
  templateUrl: './meeting-data-for-appointment.component.html',
  styleUrls: ['./meeting-data-for-appointment.component.scss']
})
export class MeetingDataForAppointmentComponent implements OnInit {
  meeting_details: any = "";
    originalNote: string = '';
  loader: boolean = false;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<MeetingDataForAppointmentComponent>,
    private apiservice: ApiService
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_NOTE){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })

  }

  ngOnInit(): void {
    this.loader = true;
    console.log(this.parentdata);
 
    if (this.parentdata.data?.note) {
      this.meeting_details =
        this.parentdata.data?.note &&
        this.parentdata.data?.note != "null"
          ? this.parentdata.data?.note
          : "";
            this.originalNote = this.parentdata.data?.note &&
        this.parentdata.data?.note != "null"
          ? this.parentdata.data?.note
          : "";
    }
    this.loader = false;
  }


  get isNoteChanged(): boolean {
  return this.meeting_details?.trim() !== this.originalNote?.trim();
}


  onConfirm() {
    let data = {
     "appointment_hash": this.parentdata.data.hash_id,
     "note": this.meeting_details ? this.meeting_details : ""
    };

    Object.keys(data).forEach((key) => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);
    this.ls.showLoader = true;
    this.apiservice.updateBookingNote(data);
  }
}
